import i18n from "../../../resources/I18n";
import { Exigence } from "../../../util/Constantes";
import * as ConstantesAssurabilite from "../../../constants/assurabilite";

interface IInstructionQuestionnaireProps {
  verdict: string;
}

function obtenirTheme(props: Readonly<IInstructionQuestionnaireProps>) {
  return props.verdict === Exigence.RapportAssurabilite ? ConstantesAssurabilite.INFORMATION : ConstantesAssurabilite.CONFIRMATION;
}


function InstructionQuestionnaire(props: Readonly<IInstructionQuestionnaireProps>) {
  const theme = obtenirTheme(props);

  return (
    <dsd-tag theme={theme}>   
        { theme === ConstantesAssurabilite.INFORMATION
              ? i18n.t("amc-validation:instruction-questionnaire-RA")
              : i18n.t("amc-validation:instruction-questionnaire-ACC")}
    </dsd-tag>

  );
}


export default InstructionQuestionnaire;
